/**
 * Updates the recently viewed products in localStorage.
 */
import { getLocalStorage } from '@theme/utilities';

export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    const localThemeStorage = getLocalStorage();
    if (!localThemeStorage) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localThemeStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    getLocalStorage()?.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    const localThemeStorage = getLocalStorage();
    if (!localThemeStorage) return [];

    try {
      return JSON.parse(localThemeStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (_error) {
      return [];
    }
  }
}
